module.exports = __webpack_public_path__ + "assets/4129a6d2d735e03687ce949c944f08cf.mp3";